import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import {AssistedDashboardComponent} from "./assisted-dashboard/assisted-dashboard.component";
import { AdminDashboardComponent } from './admin-dashboard/admin-dashboard.component';
import { BillerDashboardComponent } from './biller-dashboard/biller-dashboard.component';
import { BankDashboardComponent } from './bank-dashboard/bank-dashboard.component';
import { UserRouteAccessService } from '../shared/auth/user-route-access-service';
import { GrsAdminDashboardComponent } from './grs-admin-dashboard/grs-admin-dashboard.component';
import { ReconcilliationDashboardComponent } from './reconcilliation-dashboard/reconcilliation-dashboard.component';
import { CustomDashboardComponent } from './custom-dashboard/custom-dashboard.component';
import {BlankDashboardComponent} from './blank-dashboard/blank-dashboard.component';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminDashboardComponent,
    data: {authorities: ['ROLE_MANAGEBILLERS']},
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'assisted',
    component: AssistedDashboardComponent,
    data: {authorities: ['ROLE_SYNDICATE']},
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'custom',
    component: CustomDashboardComponent,
    data: {authorities: ['ROLE_MANAGEBILLERS'] },
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'biller',
    component: BillerDashboardComponent,
    data: {authorities: ['ROLE_BILLER'] },
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'bank',
    component: BankDashboardComponent,
    data: {authorities: ['ROLE_BANK']},
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'gateway',
    component: ReconcilliationDashboardComponent,
    data: {authorities: ['ROLE_GATEWAY']},
    canActivate: [UserRouteAccessService]
  },
  {
    path: 'grs',
    component: GrsAdminDashboardComponent,
    data: {authorities: ['ROLE_GRSUSER'] },
    canActivate: [UserRouteAccessService]
  },

  {
    path: 'blank',
    component: BlankDashboardComponent,
    data: {},
    canActivate: [UserRouteAccessService]
  },
];

@NgModule({
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DashboardsRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/dashboards/dashboards-routing.module.ts